<template>
<div id="sysadmin" v-cloak>

  <div v-if="this.state.isSysAdmin">

    <div v-if="isBusy"> <p> <b-spinner></b-spinner> </p>  </div>

    <div v-if="!isBusy && !dataError">

      <b-tabs class="mt-1" active-nav-item-class="font-weight-bold" style="max-width: 760px;">
        <b-tab no-body >
          <template v-slot:title>
            Branch User Admin
          </template>

        <b-card class="text-left" header-tag="header" bg-variant="light">
          <h5 slot="header"> 
            Branch Users 
            <span class="ml-3"> <b> {{branch}} </b> </span>
          </h5>

          <b-dropdown id="dropdown-branch" size="sm" variant="outline-dark" text="Select Branch" >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="selectBranch(item)" v-for="item in branches" :key="item.id" >{{ item.id }} {{ item.name }}  </b-dropdown-item>
          </b-dropdown>
          
          <span v-if="!branch==''" style="float: right;"> <b-button variant="outline-dark"  size="sm" @click="showAddUserModal">+ Add User</b-button> </span>

          <div id="userstable" class="mt-3">
            <b-table
              ref="usersTable"
              selectable
              select-mode="single"
              thead-class="hideheader"
              :items="branchUsers"
              :fields="fields"
              @row-selected="onRowSelected"
            >

            <template v-slot:cell(isAdmin)="data">
              
              <span>
                <b-form-checkbox
                  :id="'checkbox'+data.index"
                  :checked ="data.item.isAdmin"
                  v-on:change="updateUser(data.item,$event)"
                  switch
                  >
                  Admin
                </b-form-checkbox>
              
              </span> 

            </template>        

              <!-- scoped slot for select state -->
            <template v-slot:cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span> <b-button @click="removeUser" variant="outline-danger"  size="sm" >&#x2717;</b-button></span>
              </template>
              <template v-else>
                <span>&nbsp;</span>
              </template>
            </template>

            </b-table> 
          </div>
        </b-card>

        </b-tab>
        
        <b-tab no-body>
          <template v-slot:title>
            Standalone Journals
          </template>

          <!-- new markup for Standalone Journal Admin  -->
    
    
         <b-card class="text-left" header-tag="header" bg-variant="light">
            <h5 slot="header"> 
            Journals 
            <span class="mr-3" style="float: right;"> <b-button variant="outline-dark"  size="sm" @click="newJournal()">+ Add New</b-button> </span>
            </h5>
    
          <div id="journalstable">
            <b-table
              selectable
              select-mode="single"
              striped
              outlined
              head-variant="light"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              :busy="isBusy"
              :items="journals"
              :fields="journalFields"
            >

              <template v-slot:cell(id)="data">
              <span v-if="data.item.id"> 

                <b-button @click="() => openJournal(data.item.id)" size="sm" variant="outline-light" class="mr-2"> 
                 <img src="../assets/images/journal-icon.svg"  height="20px" v-b-tooltip.hover.v-light title="Open journal..." > 
                </b-button> 


                {{ data.value }}   
              </span>
              </template> 
    
              <template v-slot:cell(title)="data">
              <span v-if="data.item.isActive">   {{ data.value }}   </span>
              <span v-if="!data.item.isActive"> <i> {{ data.value }} </i>  <span class="text-danger font-weight-lighter">  [Inactive] </span> </span>
            
                <b-button @click="() => editJournal(data.item.id)" size="sm" variant="outline-light" class="mr-2 ml-2 "> 
                 <img src="../assets/images/edit-file-icon.svg"  height="20px"  v-b-tooltip.hover.right.v-light title="Edit..." > 
                </b-button>   
            
              </template>     
    
              <div slot="table-busy" class="text-center my-2">
                <b-spinner></b-spinner>
                <div>
                  <strong>Loading...</strong>
                </div>
              </div>
            </b-table>
          </div>

           <b-pagination
            v-show="totalRows>perPage"
            v-model="currentPage"
            align="center"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="journalstable"
            hide-ellipsis
          ></b-pagination>

        <!-- ----------------------------------------- -->

        </b-card>

        </b-tab>
        
      </b-tabs>

      <!-- The modal StandAloneJournal - NewItem -->
      <b-modal
        id="JournalItem"
        :title="modalTitle"
        size="md"
        centered
        hide-footer
      >

        <div class="d-inline-flex mr-2">
         <b-input-group-prepend class="p-2"> <span class="mr-2 mt-2 font-weight-bold"> Title: </span>
         <b-form-input id="input-title" v-model="journalItem.title" placeholder="Enter title of journal..." style="color: darkblue; min-width: 300px;" maxlength="40" autocomplete="off"></b-form-input>
         </b-input-group-prepend>
        </div>   
        <div class="d-flex flex-column m-2 ">
          <div class="d-inline font-weight-bold"> User(s): 
        </div>  
        <b-form-input id="input-users" v-model="journalItem.userAccess" placeholder="Enter user IDs e.g: jdoe, auser" style="color:darkblue;" autocomplete="off"> </b-form-input>
        </div>
        <div class="d-flex flex-column m-2 ">
          <div class="d-inline font-weight-bold"> Description of journal 
        </div>  
        <b-form-textarea id="input-description" v-model="journalItem.description" rows="3"  maxlength="500" style="color:darkblue;" autocomplete="off"> </b-form-textarea>

      </div>
       
      <div class="flex m-2"> 
        <b-alert v-if="postingError" show variant="danger">An error occurred while saving data.</b-alert>
        <b-alert v-if="postingSuccess" show variant="success"> <b> Created new journal with ID {{journalId}} </b> </b-alert>
       
       <div class="float-right m-2 mt-3">

        <div v-if="postingSuccess || postingError">
          <b-button variant="primary" v-on:click="closeJournalItemModal()"> <span class="ml-1"> OK </span> </b-button>
        </div> 
        <div v-else>
          <b-button variant="primary" v-on:click="modalType === 1 ? saveJournal() : saveNewJournal()"> &#10004; <span class="ml-1">Save</span> 
            <b-spinner class="ml-2" small  v-if="isPosting"> </b-spinner>
         </b-button>  

        </div>    

       </div>

      </div>
    
      </b-modal>
    
    </div>

    <div v-if="dataError">
      <p><b-alert show variant="danger">An error occurred loading data.</b-alert></p>
      <p>{{ error }}</p>
    </div>

  </div>
  <div v-else>
  <p><b-alert show variant="danger">(No Access)</b-alert></p>
 </div>
   
        <!-- The modal add user -->
    <b-modal
      :id="'addbranchuser'+this.branchId"
      title="Select User"
      size="md"
      button-size="sm"
      hide-footer
    >
      <AddBranchUser @addUser="addNewUser"> </AddBranchUser>
     
    </b-modal>

</div>    
</template>

<script>
import AddBranchUser from "@/components/AddBranchUser.vue";
export default {
  name: "SysAdmin",
  props: {},
  components: {
       AddBranchUser
  },

  data: function(){
      return{
          branches: [],
          journals: [],
          branchId: "",
          branch: "",
          branchUsers: [],
          fields: [{key:'selected',label:''}, {key: 'userName',label:'Name'}, {key: 'isAdmin',label:'Admin'} ],
          selected: null,
          
          perPage: 8,
          currentPage: 1,
          totalRows: 0,
          filter: null,
          isBusy: true,
          journalFields: [{key:'id', sortable: true, label:'Id',thClass: 'text-center'}, {key: 'title', sortable: true, label:'Title'} ],
          
          state: this.$store.state,
          isBusy: true,
          dataError: false,
          error: "",

          journalItem: {
            id:0,
            title: "",
            description: "",
            userAccess: "",
            isActive: 1
          },          

          newJournalItem: {
            id:0,
            title: "",
            description: "",
            userAccess: "",
            isActive: 1
          },          

          modalType: 0,  // 0=New, 1=Edit
          modalTitle: "Create New Journal",

          journalId: 0,

          isPosting: false,
          postingSuccess: false,
          postingError: false

      }
  },

  computed: {

  },

  methods: {
    selectBranch(item){
      this.branchId = item.id;
      this.branch = item.id + " " + item.name;
      this.fetchBranchUsers(item.id);
    },

    onRowSelected(items){
      this.selected=items[0];
    },    

    updateUser (user,checked){
      this.tableIsBusy = true; 
      user.isAdmin = checked; 
      this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/BranchUsers", user, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
 
          })
          .catch(error => {
              console.log(error);
          })
          .finally(() => (
            this.tableIsBusy = false
            ));
      }); 

    },

    newJournal () {
      this.modalType = 0;
      this.modalTitle = "Create New Journal";
      
      this.journalItem = this.newJournalItem;
      //reset journalItem for new
      this.journalItem.id = 0;
      this.journalItem.title = "";
      this.journalItem.description = "";
      this.journalItem.userAccess = "";
      this.isActive = 1;

      this.isPosting = false;
      this.postingSuccess = false;
      this.postingError = false;
      this.$bvModal.show("JournalItem");
    },

    editJournal (id) {
      this.journalItem = this.journals.find(item => item.id === id);
      this.modalType = 1;
      this.modalTitle = "Edit Journal " + this.journalItem.id;
      this.isPosting = false;
      this.postingSuccess = false;
      this.postingError = false;
      this.$bvModal.show("JournalItem");      
    },        

    saveNewJournal () {

      if (this.journalItem.title.trim() !== "")
      
       {
        this.isPosting = true;
        this.postingSuccess = false;
        this.postingError = false;

        this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/Journals/", this.journalItem, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            //insert new issue into issue list 
            var newJournal = response.data;
            this.journalId = newJournal.id;
            this.journals.splice(0,0,newJournal);
            this.postingSuccess = true;
          })
          .catch(error => {
            console.log (error);
            this.isPosting = false;
            this.postingSuccess = false;
            this.postingError = true;
            this.error = "ERROR";
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => {
             this.isPosting = false;
             this.isBusy = false;
          });
      });     

      }

    },

    saveJournal () {
        
        this.isPosting = true;
        this.postingSuccess = false;
        this.postingError = false;

        this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/Journal/" + this.journalItem.id, this.journalItem, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.postingSuccess = true;
            this.closeJournalItemModal();
          })
          .catch(error => {
            console.log (error);
            this.isPosting = false;
            this.postingSuccess = false;
            this.postingError = true;
            this.error = "ERROR";
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => {
             this.isPosting = false;
             this.isBusy = false;
          });
      });     

    },    

  closeJournalItemModal() {
    this.$bvModal.hide('JournalItem');
   }, 

   showAddUserModal() {
      this.$bvModal.show("addbranchuser"+this.branchId);
    },

    openJournal(id) {
      var today = this.$moment().format("YYYYMMDD"); 
      this.$router.push({ name: 'StandaloneJournal', params: { id: id.toString(), date: today } });
    },


    addNewUser(newUser) {

      this.tableIsBusy = true;  
      newUser.branchId = this.branchId;
      this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/BranchUsers", newUser, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            if (response.status == 200){
              this.branchUsers.push(newUser)
            };
          })
          .catch(error => {
              console.log(error);
          })
          .finally(() => (
            this.tableIsBusy = false
            ));
      });  

      this.$bvModal.hide("addbranchuser"+this.branchId);
    },

    removeUser() {
      this.tableIsBusy = true;
      this.$auth.acquireToken().then(token => {
        this.$http
          .delete("api/BranchUsers/" + this.branchId + "/" + this.selected.userId, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            //remove data object
            let i = this.branchUsers.findIndex(x => x.userId === this.selected.userId);
            this.branchUsers.splice(i, 1);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
             this.tableIsBusy = false;
          });
      });

     },   

    fetchBranchUsers(id) {
      this.isBusy = true;
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/BranchUsers/" + id , {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.branchUsers = response.data;
          })
          .catch(error => {
            this.errored = true;
            this.error = error.response.statusText;
          })
          .finally(() => (this.isBusy = false));
      });
    },

    fetchData() {
      this.$auth.acquireToken().then(token => {
        Promise.all([
           this.$http.get("api/Branches", {
              headers: { Authorization: "Bearer " + token }
            }),
            this.$http.get("api/Journals", {
              headers: { Authorization: "Bearer " + token }
            })
        ])
          .then(response => {
            this.branches = response[0].data;
            this.journals = response[1].data.sort((a, b) => b.id - a.id);;
            this.totalRows = this.journals.length;
          })
          .catch(error => {
            this.errored = true;
            this.error = error.response.statusText;
          })
          .finally(() => (this.isBusy = false));
      });
    },
   
  setBreadcrumb() {
     this.$store.setItem("breadcrumbs",[ 
      {
        text: 'System Admin'
      }
      ]);
    },

  },

activated: function() {
    this.setBreadcrumb();
  },

  mounted: function(){
      this.isBusy = true;
      this.fetchData();
  }
    
}
</script>

<style scoped>

#sysadmin {
  max-width: 600px;
  margin: 0 auto;
  padding-top: 5px;
}

</style>

<style>

  
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
 
 .hideheader{
    display: none;
  }

.col-centered {
  float: none;
  margin: 0 auto;
}

.pagination > li > a,
.pagination > li > span {
  color: darkred;
}

#journalstable {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 10px;
}

</style>